import * as React from "react"
import * as css from "../styles/header.module.scss"

const FolderAnimation = (props) => {
	return (
		<div className={css.folderAnimation}>
			<svg
				className={css.folderBackLeft}
				viewBox="0 0 83 65"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M63.1742 16.375H41.5742L36.1742 11H19.9742C17.0042 11 14.6012 13.4188 14.6012 16.375L14.5742 48.625C14.5742 51.5812 17.0042 54 19.9742 54H63.1742C66.1442 54 68.5742 51.5812 68.5742 48.625V21.75C68.5742 18.7938 66.1442 16.375 63.1742 16.375Z"
					fill="#FDD000"
				/>
			</svg>
			<svg
				className={css.folderBackRight}
				viewBox="0 0 83 65"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M63.1742 16.375H41.5742L36.1742 11H19.9742C17.0042 11 14.6012 13.4188 14.6012 16.375L14.5742 48.625C14.5742 51.5812 17.0042 54 19.9742 54H63.1742C66.1442 54 68.5742 51.5812 68.5742 48.625V21.75C68.5742 18.7938 66.1442 16.375 63.1742 16.375Z"
					fill="#FDD000"
				/>
			</svg>
			<svg
				className={css.paper}
				viewBox="0 0 83 65"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path d="M26.5742 21H53.5742H65.0742V39.5L53.5742 51H26.5742V21Z" fill="#FAFAFA" />
				<path
					d="M56.1742 53.4299L67.8409 41.5603C68.0733 41.3241 68.2578 41.0436 68.3836 40.7348C68.5094 40.426 68.5742 40.0951 68.5742 39.7608L68.5742 21.2391C68.5742 20.1148 68.1352 19.0366 67.3538 18.2416C66.5724 17.4466 65.5126 17 64.4076 17L27.7409 17C26.6358 17 25.576 17.4466 24.7946 18.2416C24.0132 19.0366 23.5742 20.1148 23.5742 21.2391L23.5742 49.9347C23.5742 51.059 24.0132 52.1372 24.7946 52.9322C25.576 53.7272 26.6358 54.1738 27.7409 54.1738L54.4076 54.1738C55.0701 54.1738 55.7055 53.9062 56.1742 53.4299ZM60.8659 41.4564L56.0742 46.3314L56.0742 41.4564L60.8659 41.4564ZM28.5742 22.0869L63.5742 22.0869L63.5742 36.3695L53.5742 36.3695C52.9112 36.3695 52.2753 36.6375 51.8065 37.1145C51.3376 37.5915 51.0742 38.2384 51.0742 38.913L51.0742 49.0869L28.5742 49.0869L28.5742 22.0869Z"
					fill="#FDD000"
				/>
			</svg>
			<svg
				className={css.folderFrontLeft}
				viewBox="0 0 83 65"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M55.573 24.875H33.973L28.573 19.5H12.373C9.403 19.5 7 21.9188 7 24.875L14.5738 48.6251C14.5738 51.5813 17.0038 54.0001 19.9738 54.0001H63.1738C66.1438 54.0001 68.5738 51.5813 68.5738 48.6251L60.973 30.25C60.973 27.2938 58.543 24.875 55.573 24.875Z"
					fill="#FFE361"
				/>
			</svg>
			<svg
				className={css.folderFrontRight}
				viewBox="0 0 83 65"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M55.573 24.875H33.973L28.573 19.5H12.373C9.403 19.5 7 21.9188 7 24.875L14.5738 48.6251C14.5738 51.5813 17.0038 54.0001 19.9738 54.0001H63.1738C66.1438 54.0001 68.5738 51.5813 68.5738 48.6251L60.973 30.25C60.973 27.2938 58.543 24.875 55.573 24.875Z"
					fill="#FFE361"
				/>
			</svg>
		</div>
	)
}

export default FolderAnimation
